import { createContext } from '../../utils';
import type { ButtonProps } from './button';

type ButtonContextValue = Pick<ButtonProps, 'loading' | 'mode'>;

export const [ButtonProvider, useButton] = createContext<ButtonContextValue>({
  rootComponentName: 'Button',
});
